module.exports = __webpack_public_path__ + "arrow-footer@2x.png?e66fef7a3ee8c6b22f44a9eec07f5af5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-footer@2x.png
// module id = 153
// module chunks = 0